import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
var write_info = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "id", t.id),
  /* [] */
  0]);
});
var read_info = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    id: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("id", Atdgen_codec_runtime.Decode.string, param);
    }, json)
  };
});
export { read_info, write_info };
/* write_info Not a pure module */